import React, { useState } from "react";
import { Box, IconButton, Stack } from "@mui/material";
import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import { diagnosticData, DiagnosticCategory } from "./data";
import {
  GridColDef,
  GridToolbarContainer,
  GridToolbarQuickFilter,
  GridToolbar,
} from "@mui/x-data-grid-premium";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";
import ByzNurseOkeyButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseOkeyButton";

//CKAPISIZ;446187;18032025
function CustomToolbar() {
  const { t } = useTranslate();

  return (
    <GridToolbarContainer sx={{ color: "#00B8D9" }}>
      <GridToolbar />
      <GridToolbarQuickFilter placeholder={t("search")} sx={{ ml: "auto" }} />
    </GridToolbarContainer>
  );
}

const DiagnosticPanel: React.FC = () => {
  const { t } = useTranslate();
  const [categories, setCategories] =
    useState<DiagnosticCategory[]>(diagnosticData);
  const [sortAsc, setSortAsc] = useState(true);

  const toggleCategory = (id: number) => {
    setCategories((prev) =>
      prev.map((ctg) =>
        ctg.id === id ? { ...ctg, expanded: !ctg.expanded } : ctg
      )
    );
  };

  const handleSortClick = () => {
    const sorted = [...categories].sort((a, b) =>
      sortAsc
        ? a.category.localeCompare(b.category)
        : b.category.localeCompare(a.category)
    );
    setCategories(sorted);
    setSortAsc(!sortAsc);
  };

  const rows = categories.flatMap((ctg) => {
    const headerRow = {
      id: `header-${ctg.id}`,
      name: ctg.category,
      isHeader: true,
    };
    const procedureRows =
      ctg.expanded &&
      ctg.procedures.map((proc) => ({
        id: proc.id,
        name: proc.name,
        value: proc.value,
        urgent: proc.urgent,
      }));
    return procedureRows ? [headerRow, ...procedureRows] : [headerRow];
  });

  const columns: GridColDef[] = [
    {
      field: "select",
      headerName: t("apacheii-score.selection"),
      width: 80,
      renderCell: (params) => (params.row.isHeader ? null : <ByzMuiCheckBox />),
      sortable: false,
    },
    {
      field: "name",
      headerName: "",
      flex: 1,
      minWidth: 200,
      renderHeader: () => (
        <Stack direction="row" alignItems="center" spacing={1}>
          <ByzMuiTypography sx={{ fontWeight: "bold" }}>
            {t("apacheii-score.process-name")}
          </ByzMuiTypography>
          <IconButton onClick={handleSortClick} size="small">
            {sortAsc ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />}
          </IconButton>
        </Stack>
      ),
      renderCell: (params) => {
        if (params.row.isHeader) {
          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                height: "100%", // satır yüksekliğini referans alır
                paddingY: "4px", // dikey dolgu verebilirsin
                cursor: "pointer",
              }}
              onClick={() =>
                toggleCategory(Number(params.row.id.replace("header-", "")))
              }
            >
              <IconButton
                size="small"
                color="default"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {categories.find((ctg) => `header-${ctg.id}` === params.row.id)
                  ?.expanded ? (
                  <ExpandLessIcon />
                ) : (
                  <ExpandMoreIcon />
                )}
              </IconButton>
              <ByzMuiTypography
                sx={{
                  marginLeft: "8px",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {params.row.name}
              </ByzMuiTypography>
            </Box>
          );
        }
        return params.value;
      },
      sortable: false,
    },
    {
      field: "value",
      headerName: t("apacheii-score.value"),
      width: 100,
      sortable: false,
    },
    {
      field: "urgent",
      headerName: t("apacheii-score.emergency"),
      width: 80,
      renderCell: (params) => (params.row.isHeader ? null : <ByzMuiCheckBox />),
      sortable: false,
    },
  ];

  return (
    <Box
      sx={{
        padding: "20px",
        width: "100%",
        maxHeight: "90vh",
        overflow: "auto",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
        <ByzNurseOkeyButton onClick={() => console.log("Tamam")} />
      </Box>
      <ByzMuiDataGrid
        customToolbar={CustomToolbar}
        columns={columns}
        pageSize={10}
        rows={rows}
      />
    </Box>
  );
};

export default DiagnosticPanel;
